import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Endpoints, FBLoginResponseKeys, RestartResponseKeys } from './Constants';
import { LoginResponseKeysForSTAR, LoginResponseKeysForSGA, LoginResponseKeys } from './LoginResponseKeys';
import RequestHelper from './RequestHelper';
import Utils from '../utils';
import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
import store from '../state/store';
import { setAuthorized, setToken, setRestart, setLastLoginInfo } from '../state/actions/auth';
import ENVIRONMENT_VARIABLES from '../utils/environmentVariables';
import AsyncStorage from '../utils/safeAsyncStorageProvider';
import ERROR_CODE from '../utils/errorCodes';
export default {
  _getPlatformString: function _getPlatformString() {
    var isRN = Utils.isReactNative();
    return isRN ? Utils.getPlatform() : 'web';
  },
  _getLoginEndpoint: function _getLoginEndpoint() {
    if (ENVIRONMENT_VARIABLES.APPLICATION_TARGET !== 'star') {
      return Endpoints.LOGIN;
    }

    var platform = this._getPlatformString();

    if (platform === 'android') {
      return Endpoints.ANDROID_LOGIN;
    }

    if (platform === 'ios') {
      return Endpoints.IOS_LOGIN;
    }

    return Endpoints.WEB_LOGIN;
  },
  sendMemberAccountLinkedEvent: function sendMemberAccountLinkedEvent(casinoId) {
    var trigger = Logger.getActionTrigger();
    var eventPayload = {
      member_id: casinoId,
      trigger: trigger || ''
    };
    Logger.sendEvent(EVENT_TYPES.MEMBER_ACCOUNT_LINKED, eventPayload);
  },
  restartSession: function () {
    var _restartSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token, restartToken) {
      var restartResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.RESTART_SESSION,
                body: {
                  Authentication: token,
                  restarttoken: restartToken
                }
              });

            case 3:
              restartResponse = _context.sent;

              if (!(restartResponse.success === false)) {
                _context.next = 6;
                break;
              }

              throw restartResponse.error;

            case 6:
              Logger.loginData = {
                type: 'persistent',
                email: restartResponse[RestartResponseKeys.EMAIL]
              };
              store.dispatch(setAuthorized(true));
              store.dispatch(setToken(restartResponse[RestartResponseKeys.AUTH_TOKEN]));
              store.dispatch(setRestart(restartResponse[RestartResponseKeys.RETURN_TOKEN]));
              Logger.sendEvent(EVENT_TYPES.SUCCESFUL_LOGIN, {
                success: true
              });
              return _context.abrupt("return", restartResponse);

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
                code: ERROR_CODE.LOGIN_INTERFACE_RESTART_SESSION_CATCH
              });
              return _context.abrupt("return", null);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14]]);
    }));

    function restartSession(_x, _x2) {
      return _restartSession.apply(this, arguments);
    }

    return restartSession;
  }(),

  /**
   * Helper Method to send login request, will determine the proper endpoints
   * @async
   * @param {String} email - User's Email
   * @param {String} password - User's Password
   * @returns {String} Session Id server returns
   */
  login: function () {
    var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(email, password) {
      var target, endpoint, body, loginResponse, eventPayload, playerId;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              target = ENVIRONMENT_VARIABLES.APPLICATION_TARGET;
              endpoint = target === 'star' ? this._getLoginEndpoint() : Endpoints.LOGIN;
              body = {};

              if (target === 'star') {
                body.email = email;
                body.password = password;
              } else {
                body.email = email;
                body.password = password;
                body.login_type = 'standard';
                body.platform = Utils.getPlatform();
              }

              _context2.prev = 4;
              _context2.next = 7;
              return RequestHelper.apiPost({
                endpoint: endpoint,
                body: body
              });

            case 7:
              loginResponse = _context2.sent;

              if (!(loginResponse.success === false)) {
                _context2.next = 14;
                break;
              }

              eventPayload = {
                description: 'Star log email activation required',
                code: 7
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              return _context2.abrupt("return", loginResponse);

            case 14:
              playerId = target === 'star' ? loginResponse[LoginResponseKeysForSTAR.PLAYER_ID] : loginResponse.data[LoginResponseKeysForSGA.PLAYER_ID];
              postLoginActions('Member', loginResponse.success, playerId);

            case 16:
              if (!(target === 'star')) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt("return", {
                status: loginResponse.status,
                playerId: loginResponse[LoginResponseKeysForSTAR.PLAYER_ID],
                memberID: loginResponse[LoginResponseKeysForSTAR.CASINO_ID],
                token: loginResponse[LoginResponseKeysForSTAR.AUTH_TOKEN],
                restart: LoginResponseKeysForSTAR.RETURN_TOKEN !== undefined ? loginResponse[LoginResponseKeysForSTAR.RETURN_TOKEN] : 'none'
              });

            case 18:
              return _context2.abrupt("return", {
                status: loginResponse[LoginResponseKeysForSGA.STATUS],
                playerId: loginResponse.data[LoginResponseKeysForSGA.PLAYER_ID],
                memberID: loginResponse.data[LoginResponseKeysForSGA.CASINO_ID],
                token: loginResponse.data[LoginResponseKeysForSGA.AUTH_TOKEN],
                restart: LoginResponseKeysForSGA.RETURN_TOKEN !== undefined ? loginResponse.data[LoginResponseKeysForSGA.RETURN_TOKEN] : 'none'
              });

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](4);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
                code: ERROR_CODE.LOGIN_INTERFACE_LOGIN_CATCH
              });
              throw _context2.t0;

            case 25:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[4, 21]]);
    }));

    function login(_x3, _x4) {
      return _login.apply(this, arguments);
    }

    return login;
  }(),

  /**
   * Helper to send login request after apple authentication.
   * @async
   * @param {String} idToken
   * @param {String} authCode
   * @param {String} appleUserId
   * @param {String} email
   * @param {String} firstName
   * @param {String} lastName
   */
  appleLogin: function () {
    var _appleLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(idToken, authCode, appleUserId, email, firstName, lastName) {
      var target, endpoint, body, loginResponse, eventPayload, playerId, _eventPayload;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              target = ENVIRONMENT_VARIABLES.APPLICATION_TARGET;
              endpoint = target === 'star' ? Endpoints.APPLE_LOGIN : Endpoints.LOGIN;
              body = {};

              if (target === 'star') {
                body.identity_token = idToken;
                body.auth_token = authCode;
                body.user_identifier = appleUserId;
                body.first_name = firstName;
                body.last_name = lastName;
                body.platform = this._getPlatformString();
                body.email = email;
              } else {
                body.identity_token = idToken;
                body.auth_token = authCode;
                body.user_identifier = appleUserId;
                body.first_name = firstName;
                body.last_name = lastName;
                body.email = email;
                body.platform = Utils.getPlatform();
                body.login_type = 'apple';
              }

              _context3.prev = 4;
              _context3.next = 7;
              return RequestHelper.apiPost({
                endpoint: endpoint,
                body: body
              });

            case 7:
              loginResponse = _context3.sent;

              if (!(loginResponse.success === false)) {
                _context3.next = 14;
                break;
              }

              eventPayload = {
                description: "Apple login failed reason : ".concat(loginResponse.error),
                code: 9
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw loginResponse;

            case 14:
              playerId = target === 'star' ? loginResponse[LoginResponseKeys.PLAYER_ID] : loginResponse.data[LoginResponseKeysForSGA.PLAYER_ID];
              postLoginActions('Apple', loginResponse.success, playerId);

            case 16:
              Logger.loginData = {
                type: 'apple',
                email: loginResponse[LoginResponseKeys.EMAIL]
              };

              if (loginResponse.is_new_account === true) {
                _eventPayload = {
                  email: loginResponse[LoginResponseKeys.EMAIL],
                  apple_user_id: appleUserId
                };
                Logger.sendEvent(EVENT_TYPES.USER_ACCOUNT_LINKED, _eventPayload);
              }

              if (!(target === 'star')) {
                _context3.next = 20;
                break;
              }

              return _context3.abrupt("return", {
                status: loginResponse.status,
                playerId: loginResponse[LoginResponseKeys.PLAYER_ID],
                memberID: loginResponse[LoginResponseKeys.CASINO_ID],
                token: loginResponse[LoginResponseKeys.AUTH_TOKEN],
                restart: loginResponse[LoginResponseKeys.RETURN_TOKEN]
              });

            case 20:
              return _context3.abrupt("return", {
                status: loginResponse[LoginResponseKeysForSGA.STATUS],
                playerId: loginResponse.data[LoginResponseKeysForSGA.PLAYER_ID],
                memberID: loginResponse.data[LoginResponseKeysForSGA.CASINO_ID],
                token: loginResponse.data[LoginResponseKeysForSGA.AUTH_TOKEN],
                restart: LoginResponseKeysForSGA.RETURN_TOKEN !== undefined ? loginResponse.data[LoginResponseKeysForSGA.RETURN_TOKEN] : 'none'
              });

            case 23:
              _context3.prev = 23;
              _context3.t0 = _context3["catch"](4);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context3.t0, Object.getOwnPropertyNames(_context3.t0)),
                code: ERROR_CODE.LOGIN_INTERFACE_APPLE_LOGIN_CATCH
              });
              throw _context3.t0;

            case 27:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[4, 23]]);
    }));

    function appleLogin(_x5, _x6, _x7, _x8, _x9, _x10) {
      return _appleLogin.apply(this, arguments);
    }

    return appleLogin;
  }(),

  /**
   * Helper to send login request after google authentication.
   * @async
   * @param {String} idToken
   * @param {String} googleId
   */
  googleLogin: function () {
    var _googleLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(idToken, googleId) {
      var affId, target, endpoint, bodyParams, loginResponse, eventPayload, playerId, _eventPayload2;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(Utils.getPlatform() === 'web')) {
                _context4.next = 4;
                break;
              }

              _context4.t0 = store.getState().playerInfo.aff_id;
              _context4.next = 7;
              break;

            case 4:
              _context4.next = 6;
              return AsyncStorage.getItem('aff_id');

            case 6:
              _context4.t0 = _context4.sent;

            case 7:
              affId = _context4.t0;
              target = ENVIRONMENT_VARIABLES.APPLICATION_TARGET;
              endpoint = target === 'star' ? Endpoints.GOOGLE_LOGIN : Endpoints.LOGIN;
              bodyParams = {};

              if (target === 'star') {
                bodyParams.id_token = idToken;
                bodyParams.google_id = googleId;
                bodyParams.platform = this._getPlatformString();
              } else {
                bodyParams.id_token = idToken;
                bodyParams.google_id = googleId;
                bodyParams.platform = Utils.getPlatform();
                bodyParams.login_type = 'google';
              }

              if (affId) {
                bodyParams.aff_id = affId;
              }

              _context4.prev = 13;
              _context4.next = 16;
              return RequestHelper.apiPost({
                endpoint: endpoint,
                body: bodyParams
              });

            case 16:
              loginResponse = _context4.sent;

              if (!(loginResponse.success === false)) {
                _context4.next = 23;
                break;
              }

              eventPayload = {
                description: "Google login failed reason : ".concat(loginResponse.message),
                code: 9
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw loginResponse.message;

            case 23:
              playerId = target === 'star' ? loginResponse.player_id : loginResponse.data[LoginResponseKeysForSGA.PLAYER_ID];
              postLoginActions('Google', loginResponse.success, playerId);

            case 25:
              Logger.loginData = {
                type: 'google',
                email: loginResponse.email
              };

              if (loginResponse.is_new_account === true) {
                _eventPayload2 = {
                  email: loginResponse.email,
                  google_id: googleId
                };
                Logger.sendEvent(EVENT_TYPES.USER_ACCOUNT_LINKED, _eventPayload2);
              }

              if (!(target === 'star')) {
                _context4.next = 29;
                break;
              }

              return _context4.abrupt("return", {
                status: loginResponse.status,
                playerId: loginResponse.player_id,
                memberID: loginResponse.casino_id,
                token: loginResponse.session_id,
                restart: loginResponse.restart_token
              });

            case 29:
              return _context4.abrupt("return", {
                status: loginResponse[LoginResponseKeysForSGA.STATUS],
                playerId: loginResponse.data[LoginResponseKeysForSGA.PLAYER_ID],
                memberID: loginResponse.data[LoginResponseKeysForSGA.CASINO_ID],
                token: loginResponse.data[LoginResponseKeysForSGA.AUTH_TOKEN],
                restart: LoginResponseKeysForSGA.RETURN_TOKEN !== undefined ? loginResponse.data[LoginResponseKeysForSGA.RETURN_TOKEN] : 'none'
              });

            case 32:
              _context4.prev = 32;
              _context4.t1 = _context4["catch"](13);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context4.t1, Object.getOwnPropertyNames(_context4.t1)),
                code: ERROR_CODE.LOGIN_INTERFACE_GOOGLE_LOGIN_CATCH
              });
              throw _context4.t1;

            case 36:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[13, 32]]);
    }));

    function googleLogin(_x11, _x12) {
      return _googleLogin.apply(this, arguments);
    }

    return googleLogin;
  }(),

  /**
   * Helper to send login request after fb authentication.
   * @async
   * @param {String} token
   * @param {String} uid
   */
  fbLogin: function () {
    var _fbLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(token, uid) {
      var affId, target, endpoint, bodyParams, loginResponse, eventPayload, playerId, _eventPayload3;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(Utils.getPlatform() === 'web')) {
                _context5.next = 4;
                break;
              }

              _context5.t0 = store.getState().playerInfo.aff_id;
              _context5.next = 7;
              break;

            case 4:
              _context5.next = 6;
              return AsyncStorage.getItem('aff_id');

            case 6:
              _context5.t0 = _context5.sent;

            case 7:
              affId = _context5.t0;
              target = ENVIRONMENT_VARIABLES.APPLICATION_TARGET;
              endpoint = target === 'star' ? Endpoints.FB_LOGIN : Endpoints.LOGIN;
              bodyParams = {};

              if (target === 'star') {
                bodyParams.token = token;
                bodyParams.userID = uid;
                bodyParams.platform = this._getPlatformString();
              } else {
                bodyParams.token = token;
                bodyParams.userID = uid;
                bodyParams.platform = Utils.getPlatform();
                bodyParams.login_type = 'facebook';
              }

              if (affId) {
                bodyParams.aff_id = affId;
              }

              _context5.prev = 13;
              _context5.next = 16;
              return RequestHelper.apiPost({
                endpoint: endpoint,
                body: bodyParams
              });

            case 16:
              loginResponse = _context5.sent;

              if (!(loginResponse.success === false)) {
                _context5.next = 23;
                break;
              }

              eventPayload = {
                description: "Facebook login failed, reason: ".concat(loginResponse.error),
                code: 8
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw loginResponse.message;

            case 23:
              playerId = target === 'star' ? loginResponse[LoginResponseKeys.PLAYER_ID] : loginResponse.data[LoginResponseKeysForSGA.PLAYER_ID];
              postLoginActions('Facebook', loginResponse.success, playerId);

            case 25:
              Logger.loginData = {
                type: 'facebook',
                email: loginResponse[FBLoginResponseKeys.EMAIL]
              };

              if (loginResponse[FBLoginResponseKeys.IS_NEW_USER] === 'yes') {
                _eventPayload3 = {
                  email: loginResponse[FBLoginResponseKeys.EMAIL],
                  fb_id: uid
                };
                Logger.sendEvent(EVENT_TYPES.USER_ACCOUNT_LINKED, _eventPayload3);
              }

              if (!(target === 'star')) {
                _context5.next = 29;
                break;
              }

              return _context5.abrupt("return", {
                status: loginResponse.status,
                playerId: loginResponse[LoginResponseKeys.PLAYER_ID],
                memberID: loginResponse[FBLoginResponseKeys.CASINO_ID],
                token: loginResponse[FBLoginResponseKeys.AUTH_TOKEN],
                restart: loginResponse[FBLoginResponseKeys.RETURN_TOKEN]
              });

            case 29:
              return _context5.abrupt("return", {
                status: loginResponse[LoginResponseKeysForSGA.STATUS],
                playerId: loginResponse.data[LoginResponseKeysForSGA.PLAYER_ID],
                memberID: loginResponse.data[LoginResponseKeysForSGA.CASINO_ID],
                token: loginResponse.data[LoginResponseKeysForSGA.AUTH_TOKEN],
                restart: LoginResponseKeysForSGA.RETURN_TOKEN !== undefined ? loginResponse.data[LoginResponseKeysForSGA.RETURN_TOKEN] : 'none'
              });

            case 32:
              _context5.prev = 32;
              _context5.t1 = _context5["catch"](13);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context5.t1, Object.getOwnPropertyNames(_context5.t1)),
                code: ERROR_CODE.LOGIN_INTERFACE_FB_LOGIN_CATCH
              });
              throw _context5.t1;

            case 36:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[13, 32]]);
    }));

    function fbLogin(_x13, _x14) {
      return _fbLogin.apply(this, arguments);
    }

    return fbLogin;
  }(),

  /**
   * Helper Method to send /guestlogin/ request
   * @async
   * @param {Number} [guestPlayerId] - Guest Player Id if it is a returning guest player
   * @returns {String} Session Id server returns
   */
  guestLogin: function () {
    var _guestLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(guestPlayerId) {
      var affId, bodyParams, loginResponse;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(Utils.getPlatform() === 'web')) {
                _context6.next = 4;
                break;
              }

              _context6.t0 = store.getState().playerInfo.aff_id;
              _context6.next = 7;
              break;

            case 4:
              _context6.next = 6;
              return AsyncStorage.getItem('aff_id');

            case 6:
              _context6.t0 = _context6.sent;

            case 7:
              affId = _context6.t0;
              bodyParams = {
                platform: this._getPlatformString()
              };

              if (guestPlayerId) {
                bodyParams.player_id = guestPlayerId;
              }

              if (affId) {
                bodyParams.aff_id = affId;
              }

              _context6.prev = 11;
              _context6.next = 14;
              return RequestHelper.apiPost({
                endpoint: Endpoints.GUEST_LOGIN,
                body: bodyParams
              });

            case 14:
              loginResponse = _context6.sent;

              if (!(loginResponse.success === false)) {
                _context6.next = 19;
                break;
              }

              throw loginResponse.message;

            case 19:
              postLoginActions('Guest', true, loginResponse[LoginResponseKeys.PLAYER_ID]);

            case 20:
              Logger.loginData = {
                type: 'guest',
                email: ''
              };
              return _context6.abrupt("return", {
                status: loginResponse.status,
                playerId: loginResponse[LoginResponseKeys.PLAYER_ID],
                memberID: loginResponse[LoginResponseKeys.CASINO_ID],
                token: loginResponse[LoginResponseKeys.AUTH_TOKEN],
                restart: LoginResponseKeys.RETURN_TOKEN !== undefined ? loginResponse[LoginResponseKeys.RETURN_TOKEN] : 'none'
              });

            case 24:
              _context6.prev = 24;
              _context6.t1 = _context6["catch"](11);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context6.t1, Object.getOwnPropertyNames(_context6.t1)),
                code: ERROR_CODE.LOGIN_INTERFACE_GUEST_LOGIN_CATCH
              });
              throw _context6.t1;

            case 28:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[11, 24]]);
    }));

    function guestLogin(_x15) {
      return _guestLogin.apply(this, arguments);
    }

    return guestLogin;
  }(),

  /**
   * Log in with SSO token
   * @async
   * @param {String} tokenValue - SSO token
   * @returns {String} Session Id server returns
   */
  ssoLogin: function () {
    var _ssoLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(tokenValue, tokenType) {
      var loginResponse;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return RequestHelper.apiPost({
                endpoint: Endpoints.SSO_LOGIN,
                body: {
                  tokenType: tokenType,
                  tokenValue: tokenValue,
                  platform: this._getPlatformString()
                }
              });

            case 2:
              loginResponse = _context7.sent;

              if (!(loginResponse.success === false)) {
                _context7.next = 7;
                break;
              }

              throw {
                message: loginResponse.error,
                redirectionUrl: loginResponse.error_code === 'bbe3api_ssolog_2' && loginResponse.ssoAccountActivationRedirectionURL
              };

            case 7:
              postLoginActions('Member', loginResponse.success, loginResponse.playerId);

            case 8:
              return _context7.abrupt("return", {
                status: loginResponse.status,
                memberID: loginResponse.casinoId,
                playerId: loginResponse.playerId,
                token: loginResponse.sessionId,
                restart: loginResponse.restartToken
              });

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function ssoLogin(_x16, _x17) {
      return _ssoLogin.apply(this, arguments);
    }

    return ssoLogin;
  }(),

  /**
   * Check if an email already exists in the database
   * @param {String} email
   * @param {Boolean} [true or false]
   */
  checkIfEmailExists: function () {
    var _checkIfEmailExists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(email) {
      var response;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.CHECK_IF_EMAIL_EXISTS,
                body: {
                  email: email,
                  platform: this._getPlatformString()
                }
              });

            case 3:
              response = _context8.sent;
              return _context8.abrupt("return", response);

            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](0);
              return _context8.abrupt("return", null);

            case 10:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this, [[0, 7]]);
    }));

    function checkIfEmailExists(_x18) {
      return _checkIfEmailExists.apply(this, arguments);
    }

    return checkIfEmailExists;
  }(),

  /**
   * This is step 1 for the signup process. The client will provide either email or casino card and then the server will determine what the status is for the player (new, existing, loyalty, migrated)
   * @param {string} id email or casino card #
   */
  checkIfPlayerExists: function () {
    var _checkIfPlayerExists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(id) {
      var signupResponse;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.CHECK_IF_PLAYER_EXISTS,
                body: {
                  id: id,
                  platform: this._getPlatformString()
                }
              });

            case 3:
              signupResponse = _context9.sent;

              if (!(signupResponse.success === false)) {
                _context9.next = 6;
                break;
              }

              throw signupResponse.error;

            case 6:
              return _context9.abrupt("return", signupResponse);

            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9["catch"](0);
              return _context9.abrupt("return", null);

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this, [[0, 9]]);
    }));

    function checkIfPlayerExists(_x19) {
      return _checkIfPlayerExists.apply(this, arguments);
    }

    return checkIfPlayerExists;
  }(),

  /**
   * This is step 2 for the signup process. The second step should only be done for new or loyalty status users.
   * @param {*} userStatus
   * @param {*} email
   * @param {*} password
   * @param {*} userInfo
   */
  createUser: function () {
    var _createUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(userStatus, email, password, userInfo, emailOptIn) {
      var bodyParams, affId, signupResponse;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              bodyParams = _objectSpread(_objectSpread({}, userInfo), {}, {
                userStatus: userStatus,
                platform: this._getPlatformString(),
                email: email,
                password: password,
                emailOptIn: emailOptIn
              });

              if (!(Utils.getPlatform() === 'web')) {
                _context10.next = 5;
                break;
              }

              _context10.t0 = store.getState().playerInfo.aff_id;
              _context10.next = 8;
              break;

            case 5:
              _context10.next = 7;
              return AsyncStorage.getItem('aff_id');

            case 7:
              _context10.t0 = _context10.sent;

            case 8:
              affId = _context10.t0;

              if (affId) {
                bodyParams.aff_id = affId;
              } // eslint-disable-next-line no-useless-catch


              _context10.prev = 10;
              _context10.next = 13;
              return RequestHelper.apiPost({
                endpoint: Endpoints.CREATE_USER,
                body: bodyParams
              });

            case 13:
              signupResponse = _context10.sent;

              if (signupResponse.success) {
                postLoginActions('Member', signupResponse.success);
              }

              return _context10.abrupt("return", signupResponse);

            case 18:
              _context10.prev = 18;
              _context10.t1 = _context10["catch"](10);
              throw _context10.t1;

            case 21:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this, [[10, 18]]);
    }));

    function createUser(_x20, _x21, _x22, _x23, _x24) {
      return _createUser.apply(this, arguments);
    }

    return createUser;
  }(),

  /**
   * This is the sso signup process.
   * @param {string} userStatus
   * @param {string} email
   * @param {string} password
   * @param {*} userInfo
   */
  ssoSignUp: function () {
    var _ssoSignUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(userStatus, email, password, userInfo) {
      var signupResponse;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.SSO_SIGNUP,
                body: _objectSpread(_objectSpread({}, userInfo), {}, {
                  userStatus: userStatus,
                  email: email,
                  password: password,
                  platform: this._getPlatformString()
                })
              });

            case 3:
              signupResponse = _context11.sent;

              if (!(signupResponse.success === false)) {
                _context11.next = 8;
                break;
              }

              throw signupResponse.error;

            case 8:
              postLoginActions('Member', signupResponse.success, signupResponse.player_id);

            case 9:
              this.sendMemberAccountLinkedEvent(signupResponse.casinoId);
              return _context11.abrupt("return", signupResponse);

            case 13:
              _context11.prev = 13;
              _context11.t0 = _context11["catch"](0);
              return _context11.abrupt("return", null);

            case 16:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this, [[0, 13]]);
    }));

    function ssoSignUp(_x25, _x26, _x27, _x28) {
      return _ssoSignUp.apply(this, arguments);
    }

    return ssoSignUp;
  }(),

  /**
   * This is the sso upgrade process. It is used for Star to upgrade guest user to normal unverified user.
   * @param {String} userStatus
   * @param {String} email
   * @param {String} password
   * @param {Object} userInfo
   */
  ssoUpgrade: function () {
    var _ssoUpgrade = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(userStatus, email, password, userInfo) {
      var upgradeResponse;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.SSO_UPGRADE,
                body: _objectSpread(_objectSpread({}, userInfo), {}, {
                  userStatus: userStatus,
                  email: email,
                  password: password,
                  platform: this._getPlatformString()
                })
              });

            case 3:
              upgradeResponse = _context12.sent;

              if (!(upgradeResponse.success === false)) {
                _context12.next = 6;
                break;
              }

              throw upgradeResponse.error;

            case 6:
              return _context12.abrupt("return", upgradeResponse);

            case 9:
              _context12.prev = 9;
              _context12.t0 = _context12["catch"](0);
              return _context12.abrupt("return", null);

            case 12:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this, [[0, 9]]);
    }));

    function ssoUpgrade(_x29, _x30, _x31, _x32) {
      return _ssoUpgrade.apply(this, arguments);
    }

    return ssoUpgrade;
  }(),

  /**
   * Initialize the SSO Linking process
   */
  ssoInitLinkLoyaltyCard: function () {
    var _ssoInitLinkLoyaltyCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(tokenValue) {
      var initLinkResponse;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return RequestHelper.apiPost({
                endpoint: Endpoints.SSO_INIT_LINK_LOYALTY_CARD,
                body: {
                  tokenType: 'authCode',
                  tokenValue: tokenValue,
                  platform: this._getPlatformString()
                }
              });

            case 2:
              initLinkResponse = _context13.sent;

              if (!(initLinkResponse[0].success === false)) {
                _context13.next = 5;
                break;
              }

              throw initLinkResponse[0].error;

            case 5:
              return _context13.abrupt("return", initLinkResponse[0]);

            case 6:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function ssoInitLinkLoyaltyCard(_x33) {
      return _ssoInitLinkLoyaltyCard.apply(this, arguments);
    }

    return ssoInitLinkLoyaltyCard;
  }(),

  /**
   * Complete the SSO Linking process
   */
  ssoLinkLoyaltyCard: function () {
    var _ssoLinkLoyaltyCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref) {
      var email, ssoRefreshToken, ssoAccessToken, casinoId, linkResponse;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              email = _ref.email, ssoRefreshToken = _ref.ssoRefreshToken, ssoAccessToken = _ref.ssoAccessToken, casinoId = _ref.casinoId;
              _context14.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.SSO_LINK_LOYALTY_CARD,
                body: {
                  email: email,
                  ssoRefreshToken: ssoRefreshToken,
                  casinoId: casinoId,
                  ssoAccessToken: ssoAccessToken,
                  platform: this._getPlatformString()
                }
              });

            case 3:
              linkResponse = _context14.sent;

              if (!(linkResponse[0].success === false)) {
                _context14.next = 6;
                break;
              }

              throw linkResponse[0].error;

            case 6:
              this.sendMemberAccountLinkedEvent(casinoId);
              return _context14.abrupt("return", linkResponse[0]);

            case 8:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function ssoLinkLoyaltyCard(_x34) {
      return _ssoLinkLoyaltyCard.apply(this, arguments);
    }

    return ssoLinkLoyaltyCard;
  }(),

  /**
   * Get TrackeingURL Data by affiliatieID : aff_id
   */
  getWebTrackingUrlData: function () {
    var _getWebTrackingUrlData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(aff_id) {
      var callResponse;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return RequestHelper.apiGet({
                endpoint: Endpoints.TRACKING_URL + aff_id
              });

            case 2:
              callResponse = _context15.sent;

              if (!(callResponse === false)) {
                _context15.next = 5;
                break;
              }

              throw Error('[Get-TrackingURL-response] - server returns FALSE');

            case 5:
              return _context15.abrupt("return", callResponse);

            case 6:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    function getWebTrackingUrlData(_x35) {
      return _getWebTrackingUrlData.apply(this, arguments);
    }

    return getWebTrackingUrlData;
  }()
};
export var postLoginActions = function postLoginActions(method, success) {
  if (success) {
    var eventPayload = {
      success: success
    };
    Logger.sendEvent(EVENT_TYPES.SUCCESFUL_LOGIN, eventPayload);
  }

  var lastLoginInfo = store.getState().token.lastLoginInfo;

  var updatedLoginInfo = _objectSpread(_objectSpread({}, lastLoginInfo), {}, {
    loginMethod: method
  });

  store.dispatch(setLastLoginInfo(updatedLoginInfo));
};